<style scoped>
.el-col-5{
  width: 30%;
}
.chooseBox {
  display: flex;
  /* justify-content: center; */
  margin-top: 30px;
}
.upload-txt{
  line-height: 6px;
}
</style>
<template>
  <div class="content">
    <div class="search-area">
      <el-row :gutter="20">
        <el-col :span="8"
          ><div class="search-area-div">表名称：</div>
          <el-input v-model="page.importDataName" class="ipt-sty w70f" placeholder="请输入表名称"></el-input
        ></el-col>
        <el-col :span="5">
          <el-button size="medium" type="info" @click="getData(true)">搜索</el-button>
          <el-button size="medium" type="danger" @click="empty">清空</el-button>
        </el-col>
      </el-row>
    </div>
    <!-- <div class="button-area">
      <el-button icon="el-icon-plus" size="medium" type="info" @click="add(1, '')">添加算法</el-button>
      <el-button size="medium" type="danger" @click="getDeleteData(1, '')">批量删除</el-button> 
    </div> -->
    <div class=" back-color-fff mt15" style="padding: 16px;">
      <el-table :data="tableData" @selection-change="handleSelectionChange" border style="width: 100%;">
        <el-table-column label="序号" width="60" header-align="center" align="center">
          <template slot-scope="scope">
            <!-- {{ scope.$index + 1 }} -->
            {{(page.pageIndex - 1) * page.pageSize + scope.$index + 1}}
          </template>
        </el-table-column>
        <el-table-column prop="importDataName" label="表名称" header-align="center" align="left"></el-table-column>
        <el-table-column prop="createUserName" label="操作人" header-align="center" align="center"></el-table-column>
        <el-table-column prop="createTime" label="操作时间" sortable header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.createTime | getTimeDate }}</template>
        </el-table-column>
        <el-table-column prop="bizState" label="导入状态" header-align="center" align="center">
          <template slot-scope="scope">{{ scope.row.importState | importState }}</template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <a class="txt-color" @click="uploadExcel()">下载模板 | </a>
            <a class="txt-color" @click="add(scope.row)">导入 | </a>
            <a class="txt-color-red" @click="getDeleteData(scope.row.guid)">删除</a>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-pagination
      class="pt pb back-color-fff"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[10, 100, 200]"
      :current-page="page.pageIndex"
      :page-size="page.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="page.totalRows"
    >
    </el-pagination>
    <el-dialog title="文件导入" :visible.sync="dialogFormVisible" width="550px">
       <div class="chooseBox">
            <p class="w100 t-right upload-txt">导入文件：</p>
            <el-upload
              class="upload-demo t-left mb50"
              action="#"
              :before-upload="beforeUpload"
              multiple
              :limit="1"
              accept=".xlsx,.xsl,.xls,.xlsm"
              :auto-upload="false"
              :on-change="changeFile"
              :on-exceed="handleExceed"
            >
              <el-button size="medium" type="info" class="w170">点击导入</el-button>
                  <div slot="tip" class="el-upload__tip mt30 ">
              当前仅支持 excel 格式文件（大小在2M以内），请使用 Office 2010 及以上版本，否则可能出现乱码<br />
              必须严格按照模板内容填入数据，否则可能会出现导入异常
            </div>
            </el-upload>
          </div>
    </el-dialog>
  </div>
</template>

<script>
import { route } from '@/api/apiRoute';
export default {
  data() {
    return {
      input: '',
      textTitle: '',
      right: '',
      dialogVisible: false,
      dialogFormVisible: false,
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        importDataName:''
      },
      tableData: [],
      guid:'',
      importDataName:'',
    };
  },
  created() {
    // 列表
    this.getData(false); 
  },
  methods: {
    empty() {
      let self = this;
      self.page = {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0,
        totalRows: 0,
        positionName: '', 
      };
      self.getData(true);
    },
    getData(flg) {
      let self = this;
      if (flg) {
        self.page.pageIndex = 1;
      }
      self.api.postJson(`/${serverConfig.msAiAlgorithmService}/import-data-manage/data/get`, self.page).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.tableData = res.data.data.records;
          self.page.totalPage = res.data.data.totalPages;
          self.page.totalRows = res.data.data.totalRows;
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    handleSelectionChange(val) {
      let self = this;
      self.multipleSelection = [];
      val.forEach(function(item) {
        //item 就是当日按循环到的对象
        self.multipleSelection.push(item.guid);
      });
    },
    //下载模板
    uploadExcel(){
       window.open('/2019~2020年基础数据（更新2020年数据）.xlsx');
    },
    beforeUpload(file) {
      let filename = file.name;
      let arr = filename.split('.');
      if (arr[1] !== 'xls' && arr[1] !== 'xlsx'&& arr[1] !== 'xlsm') {
        this.$message.error('上传文件只能是 excel/xls 格式!');
        return false;
      }
      return arr;
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 1 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`,
      );
    },
    changeFile(file, fileList) {
      let self = this;
      // let url = `/ms-logistics-trace-service/front/import/sap-stock?stockDate=${self.stockDate}&tenantGuid=${self.$store.state.guid}`;
      let formData = new FormData();
      formData.append('file', file.raw); //传文件
      self.api.postFile(`/${serverConfig.msAiAlgorithmService}/multiple-core/hpgc-freight?sheetNo=0`, formData).then(function(res) {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          self.$message({
            type: 'success',
            message: '导入成功',
          });
          self.getUpdateData();
          self.dialogFormVisible = false; 
        } else {
          self.$message({
            type: 'warning',
            message: res.data.msg,
          });
          return false;
        }
      });
    },
    getUpdateData() { 
       let self = this;
      self.api.put(`/${serverConfig.msAiAlgorithmService}/import-data-manage/data/update`,{'importDataName':self.importDataName,'guid':self.guid,'importState':'Y'}).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) { 
          self.getData();
        } else {
          self.$message.error(res.data.msg);
        }
      });
    },
    getDeleteData(guid) {
      let self = this;
      let query = []
      query.push(guid)
      this.$confirm('是否确认删除?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          self.api
            .postJson(`/${serverConfig.msAiAlgorithmService}/import-data-manage/data/delete`, query)
            .then(res => {
              if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
                self.$message.success('删除成功');
                self.getData(true);
              } else {
                self.$message.error(res.data.msg);
              }
            });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除',
          });
        });
    },
    add(row) {
      let self = this;
      self.guid = row.guid;
      self.importDataName = row.guid;
      this.dialogFormVisible = true; 
    },
   
    handleSizeChange(val) {
      let self = this;
      self.page.pageSize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      let self = this;
      self.page.pageIndex = val;
      this.getData();
    },
  },
};
</script>
